import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import { SideContext } from "../../state/SideContext";
import TableMovies from "./components/TableMovies";

const AllMovies = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);

  useEffect(() => {
    setSideIndex("all-movies");
    setActiveIndex("admin");
    setIsSideBarActive(true);
  }, [setActiveIndex, setIsSideBarActive, setSideIndex]);

  return (
    <>
      <div style={{ width: "100%", minHeight: 400 }}>
        <TableMovies />
      </div>
    </>
  );
};

export default AllMovies;
